import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import TStore from '../../../../types/store';
import { RECORD_TYPE_SETTINGS } from '../../../../helpers/vital-list-helper';
import { BarChartWidget } from './bar-chart-widget';
import waistEntry from '../../../../helpers/vital-list-helper/entries/waist-entry';
import bmiEntry from '../../../../helpers/vital-list-helper/entries/bmi-entry';
import { GENDER_MALE, TGenderType } from '@hilbi/web-common/types/common';

const BarChartWidgets: React.FC = () => {
  const vitalData = useSelector((store: TStore) => store.lifeId.vitalData);
  const vitalDataSettings = useSelector((store: TStore) => store.lifeId.vitalListDataSettings);
  const gender = useSelector(
    (state: TStore) => state.patients.patientDetail?.profile.sex,
  ) as TGenderType;

  const WaistCircumferenceWidget = useMemo(() => {
    const vitalEntry = waistEntry(
      vitalData,
      vitalDataSettings,
      RECORD_TYPE_SETTINGS,
      (gender as TGenderType) || GENDER_MALE,
    );
    return <BarChartWidget vitalEntry={vitalEntry} />;
  }, [vitalData?.waistCircumference, vitalDataSettings, gender]);

  const BmiWidget = useMemo(() => {
    const vitalEntry = bmiEntry(vitalData, vitalDataSettings, RECORD_TYPE_SETTINGS);

    return <BarChartWidget vitalEntry={vitalEntry} />;
  }, [vitalData?.bodyMeasure, vitalDataSettings]);

  return (
    <>
      {WaistCircumferenceWidget}
      {BmiWidget}
    </>
  );
};

export default BarChartWidgets;
